import { render, staticRenderFns } from "./NewTabButton.vue?vue&type=template&id=cb01ec10&scoped=true"
import script from "./NewTabButton.vue?vue&type=script&lang=js"
export * from "./NewTabButton.vue?vue&type=script&lang=js"
import style0 from "./NewTabButton.vue?vue&type=style&index=0&id=cb01ec10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb01ec10",
  null
  
)

export default component.exports